<template>
  <v-app>
    <v-navigation-drawer
      v-model="sideNav"
      temporary
      fixed
    >
      <v-list color="primary">
        <v-list-item-title
          v-for="item in menuItems"
          :key="item.title"
          >
          <v-btn dark dense :to="item.link">
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>{{ item.title }}</v-list-item-content>
          </v-btn>
          <v-divider></v-divider>
        </v-list-item-title>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar dark color="primary" elevation="5" dense fixed height="50px">
<!--      <v-toolbar-side-icon-->
<!--        class="hidden-sm-and-up "-->
<!--        @click.stop="sideNav = !sideNav"></v-toolbar-side-icon>-->
      <v-app-bar-nav-icon  class="hidden-sm-and-up " @click.stop="sideNav = !sideNav"></v-app-bar-nav-icon>
      <v-toolbar-title>
        <router-link to="/" tag="span" style="cursor: pointer; font-family: -apple-system,sans-serif; font-weight:bold;color:#fff;">CITE SAINTE AUGUSTINE</router-link>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-xs-only">
        <v-btn
          v-for="item in menuItems"
          :key="item.title"
          dark
          dense
          color="primary"
          class="mt-2 mr-2"
          :to="{name: item.link}">
          <v-icon left dark>{{ item.icon }}</v-icon>
          {{ item.title }}
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <main>
      <router-view></router-view>
    </main >
    <Footer></Footer>
  </v-app>
</template>

<script>

import {mdiHomeCircle, mdiAccountCheck, mdiAccountTie,mdiBookClock } from '@mdi/js'
import Footer from '@/views/home/Footer'
// import * as components from 'vuetify'
export default {
  name: 'Home',
  components: {
    Footer,
  },
  data() {
    return {
      sideNav: false,
      menuItems: [
        { icon: mdiHomeCircle, title: 'Accueil', link: 'landing' },
        { icon: mdiBookClock, title: 'Disponibilité', link: 'availability' },
        { icon: mdiAccountCheck, title: 'S\'Enregistrer', link: 'user_register' },
        { icon: mdiAccountTie, title: 'Personnel', link: 'administration' },
      ],
    }
  },
}
</script>

<style scoped>

</style>
